var location = "https://shopfront-cdn.tekoapis.com/static/8cd2ac5f60caff4e.svg";

export { location as default };
